// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createVendorPaymentCallReport = (client) => ({
    /**
     * `GET /vendor/payment-call-report`
     *
     * @operationId VendorGetPaymentCallReport
     * @source apps/backend/src/api/vendor/payment-call-report/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/payment-call-report", { method: "GET", query, headers }),
});
//# sourceMappingURL=payment-call-report.js.map